import type {
  MutatedPropertyValue,
  Product,
  TranslationKey,
} from "../../../../constants/modelCompareData/types";
import { MutatedPropertyType } from "../../../../constants/modelCompareData/types";
import { StoreId } from "@ubnt/store.core/lib/types";

export const transformPropertyValues = (
  propertyValues: Product["propertyValues"],
  formatMessage?: (message: TranslationKey) => string,
  storeId?: StoreId,
): MutatedPropertyValue[] =>
  propertyValues.map((propertyValue) => ({
    propertyId: propertyValue.propertyId,
    value:
      propertyValue.value.type === MutatedPropertyType.Translation
        ? {
            type: MutatedPropertyType.String,
            value: formatMessage
              ? typeof propertyValue.value.value === "string"
                ? formatMessage(propertyValue.value.value)
                : formatMessage(
                    propertyValue.value.value(storeId || StoreId.Us),
                  )
              : "",
          }
        : propertyValue.value,
  }));
